const DocumentTerms = () => import("@/views/document/common.vue");

const DefaultLayout = () => import("@/layouts/default.vue");

export default [
    {
        path: "/documents",
        name: "documents",
        component: DefaultLayout,
        children: [
            // 通用文档：服务条款、隐私政策等
            {
                path: ":slug",
                name: "document-detail",
                component: DocumentTerms,
                meta: {
                    titleKey: "common.routes.documentTitle",
                },
            },
        ],
    },
    {
        path: "/document/:slug",
        redirect: (to) => `/documents/${to.params.slug}`,
    },
];
